// Helpers for chat thread identifiers.
// - Listing chat: `listing-{listingId}-{buyerId}`
// - Booking chat: `booking-{bookingId}`
// - Direct chat (no listing): `direct-{userIdA}-{userIdB}` where the two UUIDs
//   are sorted alphabetically so both participants resolve to the same thread.

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function buildDirectThreadId(userA: string, userB: string): string {
  const [first, second] = [userA, userB].sort();
  return `direct-${first}-${second}`;
}

export function isDirectThread(threadId: string): boolean {
  return /^direct-[0-9a-f-]{36}-[0-9a-f-]{36}$/i.test(threadId);
}

export function getDirectThreadParticipants(threadId: string): [string, string] | null {
  const match = threadId.match(
    /^direct-([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})-([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/
  );
  if (!match) return null;
  return [match[1], match[2]];
}

export function getDirectThreadPartner(threadId: string, currentUserId: string): string | null {
  const participants = getDirectThreadParticipants(threadId);
  if (!participants) return null;
  if (!UUID_RE.test(currentUserId)) return null;
  return participants[0] === currentUserId ? participants[1] : participants[0];
}
